var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('AdvertisingForm'),_vm._l((_vm.property.advertising),function(ad){return _c('AdvertisingHistoryCard',{key:ad.id,attrs:{"advertising":ad}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }